import axios from "axios";
import Cookies from "js-cookie";
import { API_URL } from "../config";

// baseURL centralizada em src/config.js (fonte única, sem env).
export const currentServer = API_URL;

const api = axios.create({
    baseURL: currentServer,
    timeout: 45000, // 45 segundos timeout
});

// Anexa o token do estudante (se logado) nas chamadas à nossa API. Endpoints
// públicos (validação por QR) continuam funcionando sem token; os de geração de
// carteirinha passam a exigir o token do dono (estudante só gera a própria).
const anexarToken = (config) => {
    const token = Cookies.get("token");
    const url = config.url || "";
    if (token && (url.startsWith(currentServer) || url.startsWith("/"))) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
};
axios.interceptors.request.use(anexarToken);
api.interceptors.request.use(anexarToken);


export const registarAcessoValidarCertificado = async ({ idUser, tipo }) =>
    axios.post(`${currentServer}/api/registarAcessoValidarCertificado`, { idUser, tipo })

export const getUserByCPFAndNascimento = async ({ cpf, dataNascimento }) => {
    return axios.post(`${currentServer}/api/getUserByCPFAndNascimento`, {
        cpf,
        data_nascimento: dataNascimento,
    },);
};
export const getUserByCPFAndCodUsoApi = async ({ cpf, codUso }) => {
    return axios.post(`${currentServer}/api/getUserByCPFAndCodUso`, {
        cpf,
        codigo_uso: codUso,
    },);
};

// Login do estudante por email + senha.
export const loginEstudanteApi = async ({ email, senha }) =>
    axios.post(`${currentServer}/api/loginEstudante`, { email, senha });

// Esqueci minha senha — dispara o email de redefinição.
export const esqueciSenhaApi = async ({ email }) =>
    axios.post(`${currentServer}/api/esqueci-senha`, { email });

// Valida o token do link de redefinição (antes de mostrar o formulário).
export const validarTokenSenhaApi = async ({ token }) =>
    axios.get(`${currentServer}/api/redefinir-senha/${token}`);

// Redefine a senha com o token do email.
export const redefinirSenhaApi = async ({ token, senha }) =>
    axios.post(`${currentServer}/api/redefinir-senha`, { token, senha });

export const generatePdfValidadorDigitalApi = async ({ cpf, carteirinhaId }) => {
    try {
        const response = await api.post(
            '/api/validarpdf',
            { cpf, carteirinhaId },
            {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/pdf'
                }
            }
        );

         let filename = `carteirinha_${cpf}.pdf`; // Fallback caso algo dê errado
        const contentDisposition = response.headers['content-disposition'] || response.headers['Content-Disposition'];

        console.log('11', contentDisposition)

        if (contentDisposition) {
            /**
             * Este Regex procura por 'filename=' seguido por:
             * 1. Uma aspa opcional ("?)
             * 2. O conteúdo que NÃO seja aspa ou ponto e vírgula ([^";]+) -> Captura aqui!
             * 3. Uma aspa opcional final ("?)
             */
            const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/);

            if (filenameMatch && filenameMatch[1]) {
                // .trim() remove espaços e .replace remove aspas extras caso o regex falhe em algo
                filename = filenameMatch[1].trim().replace(/^"|"$/g, '');
            }
        }

        // 1. Criar o Blob
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        // 2. Criar um link invisível
        const link = document.createElement('a');
        link.href = url;

        // Nome do arquivo que aparecerá para o usuário 
        link.download = filename;

        // 3. Adicionar ao corpo do documento (necessário para alguns navegadores mobile)
        document.body.appendChild(link);

        // 4. Disparar o clique
        // No Mobile, isso geralmente inicia o download ou abre a caixa de diálogo do sistema
        link.click();

        // 5. Limpeza necessária
        document.body.removeChild(link);

        // Importante: No mobile, não podemos revogar a URL imediatamente.
        // O iOS Safari, por exemplo, pode falhar se a URL sumir antes do sistema terminar o "handshake".
        setTimeout(() => {
            window.URL.revokeObjectURL(url);
        }, 10000); // 10 segundos de folga para garantir

        return response;
    } catch (error) {
        console.error('Erro ao processar validação assinada:', error);
        throw error;
    }
};

export const generatePdfCarteirinhaDigitalApi = async ({ cpf, carteirinhaId }) => {
    try {
        const response = await api.post(
            '/api/generatePdfEstudante',
            { cpf, carteirinhaId },
            {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        );


        // --- EXTRAÇÃO DO NOME DO ARQUIVO ---
        let filename = `carteirinha_${cpf}.pdf`; // Fallback caso algo dê errado
        const contentDisposition = response.headers['content-disposition'] || response.headers['Content-Disposition'];

        console.log('11', contentDisposition)

        if (contentDisposition) {
            /**
             * Este Regex procura por 'filename=' seguido por:
             * 1. Uma aspa opcional ("?)
             * 2. O conteúdo que NÃO seja aspa ou ponto e vírgula ([^";]+) -> Captura aqui!
             * 3. Uma aspa opcional final ("?)
             */
            const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/);

            if (filenameMatch && filenameMatch[1]) {
                // .trim() remove espaços e .replace remove aspas extras caso o regex falhe em algo
                filename = filenameMatch[1].trim().replace(/^"|"$/g, '');
            }
        }
        // ------------------------------------

        // 1. Cria o Blob com o tipo MIME correto (importante para mobile reconhecer como PDF)
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        // 2. Cria o elemento <a>
        const link = document.createElement('a');
        link.href = url;

        // 3. Define o nome do arquivo

        link.setAttribute('download', filename);

        // --- AJUSTES PARA MOBILE ---
        // Abre em nova aba se o download automático falhar (comum no iOS/Safari)
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        // ---------------------------

        // 4. Executa o clique
        document.body.appendChild(link);
        link.click();

        // Pequeno delay antes de remover para garantir que o navegador mobile processe o clique
        setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }, 100);

        return response;
    } catch (error) {
        console.error('Erro ao baixar o PDF:', error);
        throw error;
    }
};


export const getUserCarteirinhaByCpfPngApi = async ({ cpf, carteirinhaId }) => {
    try {
        const response = await api.post(
            '/api/generatePngEstudante',
            { cpf, carteirinhaId },
            {
                responseType: 'blob', // 🔥 IMPORTANTE: diz ao axios que a resposta é um blob
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'image/png, application/json'
                }
            }
        );


        return response;
    } catch (error) {
        console.error('Erro na API:', error);
        throw error;
    }
};

export const getImagemByUserId = async ({ id }) =>
    axios.get(`${currentServer}/api/imagem/${id}`)

export const updateCpfByEmail = async ({ cpf, email }) =>
    axios.put(`${currentServer}/api/updateCpfByEmail`, { cpf, email })

export const getInfoAlunoByCpf = async ({ cpf }) =>
    axios.get(`${currentServer}/api/getUserByCPF/${cpf}`)

export const verifyEmailExist = async ({ userEmail }) =>
    axios.post(`${currentServer}/api/verifyEmailExist`, { userEmail }, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }
    })

export const LoginUser = async (params) =>
    axios.post(`${currentServer}/usuario/login`, params,)

export const CadastrarUser = async (params) =>
    axios.post(`${currentServer}/aluno/cadastro`, params, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }
    })
export const CadastrarEstudante = async (params) =>
    axios.post(`${currentServer}/estudante/cadastro`, params,)

export const getAllescolaridade = async (params) =>
    axios.get(`${currentServer}/aluno/escolaridade/all`, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }
    })

export const getInfoAluno = async ({ email }) =>
    axios.get(`${currentServer}/api/getUserByEmail/${email}`)

export const getAllCursos = async (params) =>
    axios.get(`${currentServer}/curso/`, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }
    })

export const getAllCursosEstudante = async (params) =>
    axios.get(`${currentServer}/estudante/cursos/info`, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }
    })


export const MatricularCurso = async ({ userId, cursoId }) =>
    fetch(`${currentServer}/estudante/${userId}/curso/${cursoId}/matricular`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
            'Content-Type': 'application/json' // Se estiver enviando dados no corpo da requisição
        },
        // Se estiver enviando dados no corpo da requisição, adicione a propriedade body:
        // body: JSON.stringify({ /* dados que você deseja enviar */ })
    })

export const desmatricularCurso = async ({ userId, cursoId }) =>
    fetch(`${currentServer}/estudante/${userId}/curso/${cursoId}/desmatricular`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
            'Content-Type': 'application/json' // Se estiver enviando dados no corpo da requisição
        },
        // Se estiver enviando dados no corpo da requisição, adicione a propriedade body:
        // body: JSON.stringify({ /* dados que você deseja enviar */ })
    })


export const concluirAula = async (idAula) => {
    const token = localStorage.getItem("token");
    const url = `${currentServer}/estudante/aula/${idAula}/concluir`;
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    };
    try {
        const response = await fetch(url, requestOptions);
        if (!response.ok) {
            throw new Error('Erro ao concluir aula');
        }
        return await response.json();
    } catch (error) {
        console.error('Erro ao concluir aula:', error);
        throw error;
    }
};

export const excluirUserById = async (id) =>
    axios.delete(`${currentServer}/estudante/delete/${id}`, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }
    })

export const editUserById = async (params) =>
    axios.put(`${currentServer}/estudante/editar`, params, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }
    })


export const shortenLink = (link) => axios.get(`https://tinyurl.com/api-create.php?url=${link}`);




